// extracted by css-extract-rspack-plugin
export default {"viewerLayout":"src-layouts-Viewer-module__viewerLayout-vnh17s"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"viewerLayout\":\"src-layouts-Viewer-module__viewerLayout-vnh17s\"}";
        // 1788963435179
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  